import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Button, CircularProgress } from '@material-ui/core';

const LoginButton = ({ urlToRedirect }) => {
    const { loginWithRedirect, isLoading } = useAuth0();

    const handleLogin = () => {
        if (urlToRedirect) {
            loginWithRedirect({
                appState: { returnTo: urlToRedirect }
            });
        } else {
            loginWithRedirect();
        }
    };

    if (isLoading) {
        <CircularProgress />;
    }

    return (
        <div className="my-4">
            <Button
                color="primary"
                fullWidth
                variant="contained"
                onClick={handleLogin}
            >
                Log In
            </Button>
        </div>
    );
};

export default LoginButton;
